/**
 * Version identifier for the current Terms of Service + Privacy Policy the
 * join form asks users to accept. Bump this whenever the legal copy materially
 * changes so `User.consentVersion` records exactly which document a user agreed
 * to. Keep in sync with the "Last updated" date shown on the legal pages.
 */
export const CONSENT_VERSION = '2026-07'

/** Single contact address for support, privacy and compliance enquiries. */
export const SUPPORT_EMAIL = 'hello@pinkflamingo.club'
